import React from 'react';
import { Outlet } from 'react-router-dom';

export function ListAchievementSo() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
